import React, {useState} from 'react';
import InfoIcon from '@mui/icons-material/Info';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { infoContent } from './infoButtonContent'

export default function InfoButton(props) {
  const { infoFor, adornment=false, edge="end", sx={ p: 0 } } = props;
  const [anchorEl, setAnchorEl] = useState();
  const content = infoContent[infoFor];

  const handleInfoClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleInfoClose = () => {
    setAnchorEl(null);
  };  

  function addIconButton(edge) {
    return (
      <IconButton
        onClick={handleInfoClick}
        tabIndex={-1}
        edge={edge}
        sx={sx}
      >
        <InfoIcon fontSize="small" />
      </IconButton>
    )
  }

  return (
    <>
      {adornment 
      ?
        <InputAdornment position="end" >
           {addIconButton(edge)}
        </InputAdornment>
      :
        addIconButton(edge)
      }

      <Popover
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleInfoClose}
          sx={{ maxWidth: '80%' }}
          anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
          }}
          transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
          }}
          slotProps={{ paper: { sx: { p: 1 }}}}
      >
          <Typography color="secondary" variant="body1" component="div">
              {content}
          </Typography>
      </Popover>
    </>
  )
}
